<template>
  <div id="addNewRoleModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header modal-bgcolor">
          <button type="button" class="close" @click="cancelPermissions">&times;</button>
          <div class="modal-title">{{ header }}</div>
          <hr />
        </div>
        <div class="modal-body">
          <div class="col-xs-12 col-sm-12 add-role">
            <div class="row mb-12">
              <div class="col-sm-12 col-xs-12 col-md-12">
                <div class="form-group">
                  Role Id
                  <span style="color: red">*</span>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <!-- <input
                  type="number"
                  placeholder="Role Id"
                  class="form-control"
                  :disabled="type !== 'new_role'"
                  v-model.number="role.role_id"
                  maxlength="5"
                /> -->

                <base-input-number
                  placeholder="Role Id"
                  :disabled="type !== 'new_role'"
                  v-model.number="role.role_id"
                  :min="1"
                  :maxlength="5"
                />
              </div>
            </div>
            <div class="row mb-12">
              <div class="col-sm-12 col-xs-12 col-md-12">
                <div class="form-group">
                  Name
                  <span style="color: red">*</span>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <input
                  type="text"
                  placeholder="Role Name"
                  class="form-control"
                  :disabled="type !== 'new_role'"
                  v-model="role.role_name"
                  maxlength="30"
                />
              </div>
            </div>
            <div class="row mb-12">
              <div class="col-sm-12 col-xs-12 col-md-12">
                <div class="form-group">
                  Description
                  <span style="color: red">*</span>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <input
                  type="text"
                  placeholder="Description"
                  class="form-control"
                  :disabled="type != 'new_role'"
                  v-model="role.description"
                  maxlength="80"
                />
              </div>
            </div>
            <div class="row mb-12">
              <div
                class="col-sm-6 col-xs-8 disp-flex"
                :class="{ 'link-disabled': type != 'new_role' }"
              >
                <span class="checkbox mr-12 top-4">
                  <label>
                    <input
                      type="checkbox"
                      :value="role.is_active"
                      v-model="role.is_active"
                      :checked="role.is_active"
                      :disabled="type != 'new_role'"
                    />
                    <span class="cr" :class="{ 'cursor-not-allowed': type != 'new_role' }">
                    </span>
                  </label>
                </span>
                <span class="cust_label">Is Active</span>
              </div>
            </div>
            <div class="row mb-15">
              <div class="col-sm-12 col-xs-12 col-md-12">
                <div class="form-group">
                  Account Type
                  <span style="color: red">*</span>
                </div>
              </div>
              <div class="col-sm-6 col-xs-12 custom-dropdown">
                <multiselect
                  :disabled="type != 'new_role'"
                  :showLabels="false"
                  :close-on-select="false"
                  class="multiselect-single-dropdown multiselect-multiple"
                  :class="!role.account_type.length ? 'un-selected' : ''"
                  placeholder="Select Account Type"
                  label="account_type"
                  track-by="account_type"
                  :multiple="true"
                  :searchable="true"
                  :clear-on-select="false"
                  :options="accountTypeList"
                  :value="role.account_type"
                >
                  <div class="selection-count" slot="selection" slot-scope="{ values, isOpen }">
                    <template v-if="!isOpen">
                      <img
                        src="/static/images/icons/filter.svg"
                        class="image-size"
                        alt="filter-icon"
                      /><span class="selected-count">{{ values.length }} Selected</span>
                    </template>
                    <template v-else-if="isOpen">
                      <img
                        src="/static/images/icons/filter.svg"
                        alt="filter-icon"
                        class="image-size"
                      />
                    </template>
                  </div>
                  <span slot="option" slot-scope="props">
                    <div
                      class="d-flex"
                      @input="updateAccountTypes(props.option)"
                    >
                      <span class="checkbox inline-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            :value="props.option.account_type"
                            :checked="role.account_type.includes(props.option.account_type_id)"
                          />
                          <span class="cr">
                          </span>
                        </label>
                      </span>
                      <div
                        :class="
                          role.account_type.includes(props.option.account_type_id)
                            ? 'font-bold'
                            : 'font-wt-400'
                        "
                        @click="updateAccountTypes(props.option)"
                      >
                        {{ props.option.account_type }}
                      </div>
                    </div>
                  </span>
                  <span slot="noResult">No matching data</span>
                </multiselect>
              </div>
            </div>
            <div class="row mr-bt-55p" v-if="type == 'new_role'">
              <div class="col-sm-12 col-xs-12 col-md-12 form-group">
                Copy Services <span style="color: red">*</span>
              </div>
              <div class="col-sm-6 col-xs-12 custom-dropdown">
                <multiselect
                  :showLabels="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  class="multiselect-single-dropdown"
                  :class="!selectedRoleId ? 'un-selected' : ''"
                  :searchable="true"
                  :options="rolesList.map((roles) => roles.role_id)"
                  :custom-label="
                    (option) => rolesList.find((role) => role.role_id == option).role_name
                  "
                  v-model="selectedRoleId"
                  @input="getRoleBasedServices(selectedRoleId)"
                  placeholder="Select Role"
                >
                  <span slot="noResult">No matching data</span>
                </multiselect>
              </div>
            </div>
            <div class="row mb-12" v-if="services.length > 0">
              <div class="col-md-12 col-sm-12 col-xs-12 bt-border">
                <div class="row">
                  <div class="col-sm-8 col-xs-8">Services access</div>
                  <div class="col-sm-3 col-xs-3 txt-alg-rt">Permissions</div>
                </div>
              </div>
              <div
                v-for="(service, index) in services"
                :key="index"
                class="col-md-12 col-sm-12 col-xs-12 bt-border"
              >
                <div class="row">
                  <div class="col-sm-9 col-xs-8">
                    <div
                      class="pb-8 pt-8"
                      :class="{ 'link-disabled': type != 'new_role' }"
                    >
                      <span class="checkbox inline-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            :value="service.access"
                            v-model="service.access"
                            :checked="service.access"
                            :disabled="type != 'new_role'"
                          />
                          <span class="cr" :class="{
                                'cursor-not-allowed': type != 'new_role'
                          }">
                          </span>
                        </label>
                      </span>
                      <span class="cust_label" :class="{ 'link-disabled': type != 'new_role' }">{{
                        service.name
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="col-sm-3 col-xs-4"
                    :class="{ 'cursor-not-allowed': type != 'new_role' }"
                  >
                    <div
                      class="edit-lnk cursor-pointer pb-8 pt-8"
                      :disabled="type != 'new_role'"
                      :class="{
                        'link-disabled pointer-events-edit': type != 'new_role'
                      }"
                      @click="openPermissionsPopup(service)"
                    >
                      edit
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 col-md-12 footer remove_button_padding">
          <div class="col-md-3 col-md-offset-6 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0">
            <button
              type="button"
              class="btn btn-block emergo-white-button"
              @click="cancelPermissions"
            >
              Cancel
            </button>
          </div>
          <div class="col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0">
            <button
              type="button"
              class="btn btn-block emergo-green-button"
              :disabled="
                loaderStatus ||
                role.role_id.toString().length == 0 ||
                role.role_name.length == 0 ||
                role.description.length == 0 ||
                role.account_type.length == 0 ||
                services.length == 0
              "
              @click="saveRole"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <rbac-add-role-modules-modal
      :services="services"
      :serviceId="serviceId"
      @updatePermissions="updatePermissions"
      @updateServiceId="updateServiceId"
    ></rbac-add-role-modules-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import RBACAddRoleModuleModal from './RBACAddRoleModuleModal.vue';
import {
  getListOfServicesBasedOnRole,
  getListOfRoleNames,
  saveRole,
  updateRole,
  getListOfAccountTypes,
  getLastRoleId
} from '../../apis/rbac';
import EventBus from '../../utils/event-bus';
import BaseInputNumber from '../Common/BaseInputNumber.vue';

export default {
  components: {
    Loader,
    'rbac-add-role-modules-modal': RBACAddRoleModuleModal,
    BaseInputNumber
  },
  props: ['type', 'roleInfo', 'header'],
  data() {
    return {
      selectedRoleId: '',
      accountTypeList: [],
      loaderStatus: false,
      serviceId: null,
      rolesList: [],
      services: [],
      role: {
        role_id: '',
        role_name: '',
        description: '',
        is_active: true,
        account_type: []
      }
    };
  },
  watch: {
    roleInfo() {
      this.updateData();
    }
  },
  methods: {
    updateAccountTypes(option) {
      if (!this.role.account_type.includes(option.account_type_id)) {
        this.role.account_type.push(option.account_type_id);
      } else {
        this.role.account_type = this.role.account_type.filter(
          (item) => item !== option.account_type_id
        );
      }
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    updateData() {
      if (this.roleInfo && Object.keys(this.roleInfo).length > 0) {
        this.role.role_id = this.roleInfo.role_id;
        this.role.role_name = this.roleInfo.role_name;
        this.role.description = this.roleInfo.description;
        this.role.is_active = this.roleInfo.is_active;
        if (this.role.account_type.length === 0) {
          // To validate json when it is updated manually
          this.accountTypeList.forEach((accountTypeDetails) => {
            if (this.roleInfo.account_type.includes(accountTypeDetails.account_type_id)) {
              this.role.account_type.push(accountTypeDetails.account_type_id);
            }
          });
        }
        this.services = this.roleInfo.services;
      }
    },
    async saveRole() {
      this.loaderStatus = true;
      const data = {
        role_id: this.role.role_id,
        role_name: this.role.role_name,
        description: this.role.description,
        is_active: this.role.is_active,
        account_type: this.role.account_type,
        services: this.services
      };
      if (this.type === 'new_role' || this.type === 'new_role_template') {
        // Save Add Role OR Import Role Template
        await saveRole(data).then(
          (response) => {
            if (response.status_code === 200) {
              this.clearNotifications();
              this.$notify({
                type: 'success',
                title: 'Role',
                text: `${response.data}`,
                group: 'custom-notification'
              });
              this.cancelPermissions();
              EventBus.$emit('updateRoleList');
              EventBus.$emit('clearUploadedJsonFile');
            }
          },
          (error) => {
            this.clearNotifications();
            this.$notify({
              type: 'error',
              title: 'Role',
              text: `${error.message}`,
              group: 'custom-notification'
            });
          }
        );
      } else {
        // update role for import
        const response = await updateRole(data);
        if (response) {
          if (response.status_code === 200) {
            this.cancelPermissions();
            EventBus.$emit('updateRoleList');
            EventBus.$emit('clearUploadedJsonFile');
          } else {
            this.clearNotifications();
            this.$notify({
              type: 'error',
              title: 'Role',
              text: 'Add Role Failed',
              group: 'custom-notification'
            });
          }
        }
      }
      this.loaderStatus = false;
    },
    updateServiceId() {
      this.serviceId = null;
    },
    updatePermissions(permissions, serviceId) {
      this.services.forEach((service, index) => {
        if (service.id === serviceId) {
          this.services[index] = permissions;
        }
      });
      this.serviceId = null;
    },
    cancelPermissions() {
      this.role = {
        role_id: '',
        role_name: '',
        description: '',
        is_active: true,
        account_type: []
      };
      this.selectedRoleId = '';
      this.accountTypeList = [];
      this.rolesList = [];
      this.services = [];
      this.serviceId = null;
      $('#addNewRoleModal').modal('hide');
      if (this.type !== 'new_role') {
        this.$emit('uploadJsonModal');
      }
    },
    async getRoleBasedServices(roleId) {
      this.loaderStatus = true;
      const response = await getListOfServicesBasedOnRole(roleId);
      this.services = response.services;
      this.loaderStatus = false;
    },
    getRoleNameById(id) {
      const role = this.rolesList.find((r) => r.role_id === id);
      return role ? role.role_name : undefined;
    },
    openPermissionsPopup(service) {
      this.serviceId = service.id;
      $('#rbacAddRoleModulesModal').modal({
        backdrop: 'static',
        keyboard: false
      });
    }
  },
  mounted() {
    $('#addNewRoleModal').on('shown.bs.modal', async () => {
      this.loaderStatus = true;
      const response = await getListOfAccountTypes();
      this.accountTypeList = response.filter(
        (accountTypes) => accountTypes.account_type_id !== 4 && accountTypes.account_type_id !== 5
      );
      if (this.type === 'new_role') {
        this.role.role_id = (await getLastRoleId()) + 1;
        this.rolesList = await getListOfRoleNames();
      } else if (this.type === 'new_role_template' || this.type === 'existing_role_template') {
        this.updateData();
      }
      this.loaderStatus = false;
    });
  }
};
</script>
<style scoped lang="scss">
$font-family-Roboto: Roboto;
$font-style-normal: normal;
.modal-body {
  height: 65vh;
  overflow: auto;
}
.modal-header {
  padding: 15px 30px;
  &.modal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: 5px;
    padding-bottom: 0px;
  }
  .close {
    background: none;
    opacity: 0.5;
    height: 17px;
    line-height: 28px;
    color: $deep-gray;
    width: 17px;
    border-radius: 20px;
    font-weight: $font-weight-small;
    outline: none;
    font-size: $font-38;
    z-index: 1;
  }
}
.modal-title {
  font-family: $font-family-Roboto;
  font-style: $font-style-normal;
  font-weight: $font-weight-medium;
  font-size: $font-20;
  color: $primary;
}
.mr-bt-55p {
  margin-bottom: 55px;
}
.mb-12 {
  margin-bottom: 12px;
}
::v-deep .custom-dropdown {
  .el-input__inner {
    font-weight: $font-weight-medium;
    font-size: $font-16;
    line-height: 19px;
    color: $primary !important;
    border: 0.5px solid $deep-gray !important;
    border-radius: 20px;
  }
  .el-select {
    width: 100%;
  }
}
.footer {
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: $white;
}
.txt-alg-rt {
  text-align: right;
}

.disp-flex {
  display: flex;
}
.bt-border {
  border-bottom: 1px solid $gray74;
}
.cust_label {
  font-size: $font-14;
  font-weight: $font-weight-400;
}
.add-role {
  .mb-12 {
    &:last-child {
      > .bt-border {
        &:last-child {
          > div.row {
            &:last-child {
              padding-bottom: 20px;
            }
          }
        }
      }
    }
  }
}
.edit-lnk {
  font-family: $font-family-Roboto;
  font-style: $font-style-normal;
  @include fontItems($font-16, 22px, $font-weight-normal);
  text-align: right;
  padding-right: 70%;
  color: $messenger-blue;
}
.link-disabled {
  opacity: 0.4;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.pointer-events-edit {
  pointer-events: none;
}
$color_1: #0b3c61;
$background-color_1: #fff;
$border-color_1: #fff;

::v-deep .custom-dropdown {
  .el-tag.el-tag--info {
    background-color: $white;
    border-color: $white;
    color: $primary;
    font-size: $font-14;
    font-weight: $font-weight-medium;
  }
}
::v-deep .custom-dropdown {
  .el-tag {
    .el-icon-close {
      font-size: 20px;
    }
  }
}

@media screen and (max-width: 410px) {
  .txt-alg-rt {
    padding: 0px;
  }
  .cust_label {
    margin-left: 1px;
  }
}
</style>
